var s = Object.defineProperty;
var i = (t, e, a) => e in t ? s(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a;
var o = (t, e, a) => i(t, typeof e != "symbol" ? e + "" : e, a);
import { BaseEnvironment as m } from "./main6.js";
class c extends m {
  constructor() {
    super(...arguments);
    /**
     * Webmotors base domain
     *
     */
    o(this, "domain", "webmotors.com.br");
    /**
     * Webmotors api URL
     *
     */
    o(this, "apiURL", `https://www.${this.domain}/api`);
    /**
     * Webmotors base URL
     *
     */
    o(this, "baseURL", `https://www.${this.domain}`);
    /**
     * Webmotors private api URL
     *
     */
    o(this, "apiPrivateURL", "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/prd/api");
    /**
     * Cookie domain
     *
     */
    o(this, "cookieDomain", [this.domain, `.${this.domain}`, `www.${this.domain}`]);
    /**
     * Auth Cookie Name on production environment
     *
     */
    o(this, "authCookieName", "webmotors.jwt.token");
    /**
     * Access Token Cookie Name on production environment
     *
     */
    o(this, "accessTokenCookieName", "webmotors.access.token");
    /**
     * Refresh Token Cookie Name on production environment
     *
     */
    o(this, "refreshTokenCookieName", "webmotors.refresh.token");
    /**
     * Vehicle photo path on PROD environment
     *
     */
    o(this, "photoPath", "https://image.webmotors.com.br");
    /**
     * Webmotors chat api websocket URL
     *
     */
    o(this, "chatApiUrl", "wss://chat.webmotors.com.br");
    /**
     * Adobe SDK path
     *
     */
    o(this, "adobeSDK", "https://assets.adobedtm.com/0a9348ad03c2/c7e2a344c6e9/launch-3d19ca046842.min.js");
    /**
     * Hot deal image path on PROD environment
     *
     */
    o(this, "hotDealImage", "https://image.webmotors.com.br/feiroes/imagens/prd/_portal/");
    /**
     * Seller shield image path
     */
    o(this, "sellerShieldImage", "https://webmotors.com.br/img/blindagem/");
    /**
     * Login route
     *
     */
    o(this, "loginRoute", `https://www.${this.domain}/login`);
  }
}
export {
  c as ProductionEnvironment
};
